import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GravelCalcType } from 'src/app/server-api/models';
import { EnumDropdownComponent } from 'src/app/utils-flc/enum-dropdown/enum-dropdown.component';

@Component({
  selector: 'app-gravel-calc-type-dropdown',
  templateUrl: './gravel-calc-type-dropdown.component.html',
  styleUrls: ['./gravel-calc-type-dropdown.component.css']
})
export class GravelCalcTypeDropdownComponent extends EnumDropdownComponent {

  constructor(
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'gravel-calc-type-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.items = [];
    
    this.items = Object.keys(GravelCalcType).map(key => GravelCalcType[key]);
            
    this.setPreSelect(this.preSelect);
  }
}
